import { createFileRoute } from '@tanstack/react-router'
import { GoldSellRequestsTable } from '@/features/gold-sell-requests'

export const Route = createFileRoute(
  '/_authenticated/wallet/gold-sell-requests'
)({
  component: GoldSellRequestsPage,
})

function GoldSellRequestsPage() {
  return <GoldSellRequestsTable />
}
